import { createContext, useContext } from 'react';

/**
 * The opener of the ONE command palette the desktop shell (`Layout`) owns.
 *
 * `useCommandPalette` is plain component state (a `useDisclosure`), so calling
 * it from a page gives that page a private copy of the palette's open flag
 * that no rendered palette reads: the click would do nothing. Surfaces below
 * the shell (the workspace top bar's search) open the real palette through
 * this instead.
 *
 * Null where the shell renders no palette (onboarding, or outside the
 * shell), so a consumer can leave its search entry out rather than show a
 * dead one.
 */
export const CommandPaletteContext = createContext<(() => void) | null>(null);

export function useOpenCommandPalette(): (() => void) | null {
  return useContext(CommandPaletteContext);
}
